import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from "@emotion/react";
import { Colors } from "@zapier/design-system";
import { responsiveStyles } from "@zapier/responsive-utils";
import { useSize } from "@zapier/upsells/esm/hooks";
const styles = {
    closeButton: css `
    position: absolute;
    right: 40px;
    top: 40px;
    z-index: 1000;
  `,
    root: ({ size }) => responsiveStyles(size, {
        small: css `
        background-color: ${Colors.neutral100};
        border-radius: 5px;
        box-shadow: rgb(0 0 0 / 10%) 0px 5px 10px 0px;
        margin: 10px 10px calc(10px + 40px); // 40px handles bottom toolbar in iOS Safari.
        max-height: calc(100vh - 70px);
        overflow: hidden; // Scroll bar messes up some nudge images
        padding: 30px;
        width: 100%;
      `,
        medium: css `
        border-radius: 5px;
        margin: 30px;
        max-height: 650px;
        max-width: 869px;
        min-width: 550px;
        padding: 0px; // Nudge state has an image that goes all the way to the modal edge
        width: auto;
      `,
    }),
};
export const NudgeViewModalContent = ({ children, closeButton }) => {
    const size = useSize();
    return (_jsxs("div", { css: styles.root({ size }), children: [_jsx("div", { css: styles.closeButton, children: closeButton }), children] }));
};

// @zapier/upsells@8.0.3 (1de7a616e)
